module.exports = __webpack_public_path__ + "img/banner_2000x2.7fe09da3.webp";